import { isIOS } from 'react-device-detect';

export default function isIos() {
    return isIOS;

    //return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}
